// extracted by css-extract-rspack-plugin
export default {"granetCodeEditor":"granetCodeEditor__HieoZ"};